// Components
import { BaseHeader } from 'components'
import { LayoutDefaultFooter } from './components'

// Interfaces
import { ILayoutDefaultProps } from './interfaces'

const LayoutDefault = ({ children }: ILayoutDefaultProps) => {
  return (
    <>
      {/* Header */}
      <BaseHeader />

      {/* You content goes here */}
      {children}

      {/* Footer */}
      <LayoutDefaultFooter />
    </>
  )
}

export { LayoutDefault }
